export default __webpack_public_path__ + "static/media/ies_MasInfo.2f0a1c8d.png";